import { Box } from "@mui/material";
import { Student } from "../../providers/studentsProvider";
import { LatestActivitiesCard } from "./cards/LatestActivitiesCard";
import { LatestInvoicesCard } from "./cards/LatestInvoicesCard";
import { PaymentsCard } from "./cards/PaymentsCard";
import { TheoryProgressCard } from "./cards/TheoryProgressCard";
import { TrainingsCard } from "./cards/TrainingsCard";
import { StudentCourseProgressCards } from "./cards/CourseProgressCard";

export function StudentOverviewTab(props: { student: Student; trainingIncludesTheoryLessonsOrExam: boolean }) {
  const { student, trainingIncludesTheoryLessonsOrExam } = props;
  return (
    <Box sx={{ containerType: "inline-size" }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gap: "24px",
          "& .StudentOverviewTab-column": {
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            minWidth: 0,
          },
          "@container (max-width: 600px)": {
            gridTemplateColumns: "minmax(0, 1fr)",
            "& .StudentOverviewTab-column": { display: "contents" },
            "& .StudentOverviewTab-courseProgress": { order: 1 },
            "& .StudentOverviewTab-training": { order: 2 },
            "& .StudentOverviewTab-theory": { order: 3 },
            "& .StudentOverviewTab-payments": { order: 4 },
            "& .StudentOverviewTab-latestActivities": { order: 5 },
            "& .StudentOverviewTab-latestInvoices": { order: 6 },
          },
        }}
      >
        <Box className="StudentOverviewTab-column">
          <StudentCourseProgressCards student={student} />
          <Box className="StudentOverviewTab-training">
            <TrainingsCard student={student} />
          </Box>
          <Box className="StudentOverviewTab-latestActivities">
            <LatestActivitiesCard student={student} />
          </Box>
        </Box>
        <Box className="StudentOverviewTab-column">
          {trainingIncludesTheoryLessonsOrExam && (
            <Box className="StudentOverviewTab-theory">
              <TheoryProgressCard student={student} />
            </Box>
          )}
          <Box className="StudentOverviewTab-payments">
            <PaymentsCard student={student} />
          </Box>
          <Box className="StudentOverviewTab-latestInvoices">
            <LatestInvoicesCard student={student} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
